<template>
  <div>
    <v-dialog
      v-model="table_chart.openRasterLayerTableChartPopup"
      min-width="500px"
      width="80vw"
      :fullscreen="mobileBreakpoints()"
      @click:outside="resetRasterForm()"
    >
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
      <v-card>
        <v-card-title
          v-if="table_chart.isTable"
          class="green--text text--accent-4 d-flex justify-space-between"
        >
          <span>{{ $t('Marker.tab') }}</span>
          <v-icon
            color="red"
            size="30"
            @click="resetRasterForm()"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-title
          v-else
          class="green--text text--accent-4 d-flex justify-space-between"
        >
          <span>{{ $t('Marker.graph') }}</span>
          <v-icon
            color="red"
            size="30"
            @click="resetRasterForm()"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text v-if="renderContent">
          <div class="d-flex align-center">
            <v-select
              v-model="chipSelectedRasterLayers"
              :items="rasterLayers"
              :item-text="getRasterSelectorLabel"
              :label="$t('ServiceCard.layers')"
              chips
              multiple
              :counter="!table_chart.isTable ? 2 : undefined"
              return-object
              item-color="RMprimary"
              color="RMprimary"
              @input="limiterSelect"
            >
              <template v-slot:item="{ item }">
                {{ getRasterSelectorLabel(item) }}
              </template>
              <template v-slot:selection="{ item}">
                <v-chip
                  small
                  color="RMprimary"
                  class="mt-2"
                  text-color="white"
                  close
                  @click:close="chipSelectedRasterLayers.splice(chipSelectedRasterLayers.findIndex(chip => chip.layer_name === item.layer_name), 1)"
                >
                  <span>{{ getRasterSelectorLabel(item) }}</span>
                </v-chip>
              </template>
            </v-select>
            <v-btn
              color="#0da344"
              class="ml-4"
              small
              outlined
              :disabled="isConfirmDisabled"
              @click="updateRasterTableChart(chipSelectedRasterLayers)"
            >
              {{ $t('ServiceCard.confirm') }}
            </v-btn>
          </div>
          <div>
            <div
              class="mt-2 mb-2 d-flex flex-column"
            >
              <div class="mb-4 d-flex flex-column">
                <span><b>{{ $t('Ticketing.address') }}:</b> {{ map.placeAddress }}</span>
                <div>
                  <span class="mr-2"><b>{{ $t('Ticketing.latitude') }}:</b> {{ map.coordsLonLat[1] }}</span>
                  <span><b>{{ $t('Ticketing.longitude') }}:</b> {{ map.coordsLonLat[0] }}</span>
                </div>
              </div>
              <!-- Menù export -->
              <v-menu
                v-if="table_chart.isTable && table_chart.rasterTableItems.length > 0"
                offset-y
                class="text-center"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="#4caf50"
                    small
                    outlined
                    max-width="min-content"
                    style="margin-left: auto;"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ $t('ServiceCard.export') }}
                    <v-icon
                      v-if="table_chart.isTable"
                      class="ma-1"
                      color="#4caf50"
                    >
                      mdi-table
                    </v-icon>
                    <v-icon
                      v-else
                      class="ma-1"
                      color="#4caf50"
                    >
                      mdi-chart-line
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="item in exportTableExtensions"
                    :key="item.type"
                    :color="item.color"

                    @click="exportTable(item.type)"
                  >
                    <v-list-item-icon class="mr-1 ml-2">
                      <v-icon
                        :color="item.color"
                      >
                        mdi-file-export
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span
                          :style="`color: ${item.color}`"
                        >{{ item.type }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <v-alert
              v-model="wpsLimitsExceeded"
              dense
              type="warning"
              icon="mdi-alert-outline"
              class="mt-4"
              transition="scale-transition"
              dismissible
            >
              {{ $t('Table.wpsLimitsExceeded') }}
            </v-alert>
            <div v-if="table_chart.isTable">
              <v-data-table
                id="requests-table"
                fixed-header
                :height="isLandscape() ? '100%' : (table_chart.rasterTableItems.length > 8 ? '450px': '') "
                :headers="table_chart.rasterTableHeaders"
                :items="table_chart.rasterTableItems"
                :items-per-page="10"
                :mobile-breakpoint="0"
                :footer-props="{
                  itemsPerPageAllText: $t('Table.all'),
                  itemsPerPageText: $t('Table.rowsPerPage'),
                  pageText: `{0}-{1} ${$t('Table.of')} {2}`
                }"
                :no-data-text="$t('Table.noData')"
                class="elevation-1"
              >
                <template v-slot:[`item.time`]="{ item }">
                  {{ item.time.includes('/') ? item.time : formatDate(item.time) }}
                </template>
              </v-data-table>
            </div>
            <div v-else>
              <div
                v-if="renderCharts"
              >
                <v-alert
                  v-if="mobileBreakpoints() && !isLandscape()"
                  icon="mdi-phone-rotate-landscape"
                  color="primary"
                  outlined
                  text
                >
                  {{ $t('Graph.rotateMobile') }}
                </v-alert>

                <div
                  v-if="table_chart.rasterVectorChartDataSetLine.length > 0"
                  class="d-flex justify-space-between align-center"
                >
                  <v-radio-group
                    v-model="mandatoryChart"
                    row
                  >
                    <v-radio
                      :label="$t('Graph.line')"
                      :ripple="true"
                      value="line"
                      color="RMprimary"
                    />
                    <v-radio
                      :label="$t('Graph.bar')"
                      :ripple="true"
                      value="bar"
                      color="RMprimary"
                    />
                  </v-radio-group>

                  <v-menu
                    offset-y
                    class="text-center"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="#4caf50"
                        small
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ $t('ServiceCard.export') }}
                        <v-icon
                          class="ma-1"
                          color="#4caf50"
                        >
                          mdi-chart-line
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="item in exportChartExtensions"
                        :key="item.type"
                        :color="item.color"
                        @click="exportChart(item.type)"
                      >
                        <v-list-item-icon class="mr-1 ml-2">
                          <v-icon
                            :color="item.color"
                          >
                            mdi-file-export
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <span :style="`color: ${item.color}`">{{ item.type }}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>

                <v-card
                  v-if="mobileBreakpoints() && tooltipData"
                  outlined
                  class="mb-2 pa-2 chart-tooltip-card"
                >
                  <div class="font-weight-bold">
                    {{ tooltipData.title }}
                  </div>
                  <div
                    v-for="(item, i) in tooltipData.items"
                    :key="i"
                    class="d-flex align-center"
                  >
                    <span
                      class="chart-tooltip-color mr-2"
                      :style="{ backgroundColor: item.color }"
                    />
                    <span>{{ item.text }}</span>
                  </div>
                </v-card>

                <div style="overflow-x: auto;">
                  <v-alert
                    v-if="table_chart.rasterVectorChartDataSetLine.length === 0"
                    dense
                    type="warning"
                    icon="mdi-alert-outline"
                    class="mt-4"
                    transition="scale-transition"
                  >
                    {{ $t('Table.noData') }}
                  </v-alert>
                  <div
                    v-else
                    :style="{ width: calcWidth() + 'px', minWidth: '100%', maxWidth: '5000px' }"
                  >
                    <line-chart
                      v-if="mandatoryChart === 'line'"
                      ref="chart"
                      :datasets="table_chart.rasterVectorChartDataSetLine"
                      :is-daily-data="isDailyData"
                      @chart_data="chartData = $event"
                      @tooltip_data="tooltipData = $event"
                      @legend_data="legendItems = $event"
                    />
                    <bar-chart
                      v-else
                      ref="chart"
                      :datasets="table_chart.rasterVectorChartDataSetBar"
                      :is-daily-data="isDailyData"
                      @chart_data="chartData = $event"
                      @tooltip_data="tooltipData = $event"
                      @legend_data="legendItems = $event"
                    />
                  </div>
                </div>

                <div
                  v-if="legendItems.length"
                  class="d-flex flex-wrap justify-center mt-2 chart-legend"
                >
                  <div
                    v-for="item in legendItems"
                    :key="item.datasetIndex"
                    class="d-flex align-center chart-legend-item"
                    :class="{ 'chart-legend-item--hidden': item.hidden }"
                    @click="$refs.chart.toggleDataset(item.datasetIndex)"
                  >
                    <span
                      class="chart-legend-color mr-1"
                      :style="{ backgroundColor: item.color }"
                    />
                    <span>{{ item.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-spacer
          v-else
          class="pb-16"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { logoRadarmeteo, logoCertification } from '@/base64img.js';
import moment from 'moment-business-days';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { formatLayerLabel } from '@/utils.js';

export default {
  components: {
    LineChart: () => import('@/components/utils/LineChart'),
    BarChart: () => import('@/components/utils/BarChart')
  },
  props: {
    selectedRasterLayer: {
      type: Object,
      default: null
    },
    rasterLayers: {
      type: Array,
      default: () => []
    },
    tableChartRangeDate: {
      type: String,
      default: ''
    },
    isAnimation: {
      type: Boolean,
      default: false
    },
    isDailyData: {
      type: Boolean,
      default: false
    },
    isRefreshingData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      mandatoryChart: 'line',
      overlay: false,
      renderCharts: false,
      renderContent: false,
      wpsLimitsExceeded: false,
      chipSelectedRasterLayers: [],
      chartData: {},
      tooltipData: null,
      legendItems: [],
      exportTableExtensions: [
        { type: 'csv', color: 'green' },
        { type: 'pdf', color: 'red' }
        // {type: "doc", color: "#2196f3" }
      ],
      exportChartExtensions: [
        { type: 'png', color: '#43a047' },
        { type: 'jpg', color: '#43a047' }
      ]
    };
  },
  computed: {
    ...mapState(['map', 'app_user', 'table_chart']),
    isConfirmDisabled() {
      const len = this.chipSelectedRasterLayers.length;

      return !this.table_chart.isTable
        ? len > 2 || len <= 0
        : len <= 0;
    }
  },
  watch: {
    $route() {},
    mandatoryChart() {
      this.tooltipData = null;
    },
    isRefreshingData: {
      handler(newValue, oldValue) {
        const id = this.selectedRasterLayer.service_id;

        const wasRefreshing = Array.isArray(oldValue) && oldValue.includes(id);
        const isCompleted = !newValue.includes(id);

        if (wasRefreshing && isCompleted && this.table_chart.openRasterLayerTableChartPopup) {
          this.updateRasterTableChart(this.chipSelectedRasterLayers);
        }
      }
    }
  },
  created() {
    if (!this.isAnimation) {
      this.chipSelectedRasterLayers = [...this.rasterLayers];
    } else {
      this.chipSelectedRasterLayers = [this.selectedRasterLayer];
    }

    this.updateRasterTableChart(this.chipSelectedRasterLayers);
  },
  methods: {
    ...mapActions(['getLayerCoordinatesDataAction', 'getUpdatedRasterTableChartAction', 'getElevationAction', 'getSeaDistanceAction', 'storeToastMessage']),
    getRasterSelectorLabel(layer) {
      const layerKey = `${layer.ws_name}:${layer.layer_name}`;

      return formatLayerLabel(
        this.$t(`${layerKey}_serviceID:${layer.service_id}.label`),
        layer?.udm
      );
    },
    isLandscape() {
      return /Mobi|Android/i.test(navigator.userAgent) && window.innerHeight < window.innerWidth;
    },
    mobileBreakpoints() {
      return /Mobi|Android/i.test(navigator.userAgent) || this.isLandscape();
    },
    getFilename() {
      const serviceName = this.$t(`ServiceCard.${this.selectedRasterLayer.service_id}.title`).replaceAll(' ', '_');
      let startDate = '';
      let endDate = '';
      let fileName = '';

      if (this.table_chart.isTable) {
        fileName = `Radarmeteo_${this.$t('Marker.tab')}_${serviceName}`;
        startDate = this.table_chart.rasterTableItems[0].time;
        endDate = this.table_chart.rasterTableItems.at(-1).time;
      } else {
        fileName = `Radarmeteo_${this.$t('Marker.graph')}_${serviceName}`;
        startDate = this.chartData.labels[0];
        endDate = this.chartData.labels.at(-1);
      }

      if (this.chipSelectedRasterLayers.length == 1) {
        const layer = this.chipSelectedRasterLayers[0];
        const varNameTrad = this.$t(`${layer.ws_name}:${layer.layer_name}_serviceID:${layer.service_id}.label`).replaceAll(' ', '_');
        fileName += `_${varNameTrad}`;
      }

      if (startDate != '' && endDate != '') {
        if (this.isDailyData) {
          startDate = moment(startDate).format('DDMMYYYY');
          endDate = moment(endDate).format('DDMMYYYY');
        } else {
          startDate = moment(startDate).format('DDMMYYYY_HHmm');
          endDate = moment(endDate).format('DDMMYYYY_HHmm');
        }

        fileName += `_${startDate}_${endDate}`;
      }

      if (this.map.placeAddress) {
        const loc = this.map.placeAddress.split(', ').at(-2).replace(/^\d+\s*/, '').trim().replaceAll(' ', '_');
        const state = this.map.placeAddress.split(', ').at(-1).trim().replaceAll(' ', '_');
        fileName += `_${loc}_${state}`;
      }

      if (this.map.coordsLonLat) {
        const lat = `Lat_${parseFloat(this.map.coordsLonLat[1]).toFixed(2)}`;
        const lon = `Lon_${parseFloat(this.map.coordsLonLat[0]).toFixed(2)}`;
        fileName += `_${lat}_${lon}`;
      }

      return fileName;
    },
    formatDate(date) {
      const m = moment(date, moment.ISO_8601, true);

      if (!m.isValid()) {
        return date.includes('T')
          ? date.replace('Z', '').replace(/-/g, '/')
          : date;
      }

      if (this.isDailyData) {
        return m.format('DD/MM/YYYY');
      }

      const seconds = m.second();
      const milliseconds = m.millisecond();

      let format = 'DD/MM/YYYY HH:mm';

      if (milliseconds !== 0) {
        format = 'DD/MM/YYYY HH:mm:ss.SSS';
      } else if (seconds !== 0) {
        format = 'DD/MM/YYYY HH:mm:ss';
      }

      return m.format(format);
    },
    async exportTable(type) {
      const reportDate = `Aggiornamento del: ${moment().format('DD/MM/YYYY')} delle ore ${moment().format('HH:mm')}`;
      const reportName = 'Radarmeteo - ' + this.$t(`ServiceCard.${this.selectedRasterLayer.service_id}.title`);
      const fileName = this.getFilename();
      this.table_chart.rasterTableItems.forEach(items => {
        if (!(items.time).includes('/')) {
          items.time = this.formatDate(items.time);
        }
      });

      if (type === 'pdf') {
        await this.getSeaDistanceAction([this.map.coordsLonLat[1], this.map.coordsLonLat[0]]);
        await this.getElevationAction([this.map.coordsLonLat[1], this.map.coordsLonLat[0]]);

        require('jspdf-autotable');
        const header = [];
        this.table_chart.rasterTableHeaders.forEach(item => header.push({
          header: (item.text === 'time') ? this.$t('ServiceCard.date') : item.text,
          dataKey: item.value
        }));
        const data = [...this.table_chart.rasterTableItems];
        const doc = new jsPDF('l', 'mm', [297, 210], true);
        const totalPagesExp = '{total_pages_count_string}';

        const data1_alternativeTemplate = [{
          heading: this.$t('Ticketing.address'),
          value: this.map.placeAddress
        },
        {
          heading: 'Coordinate',
          value: this.map.coordsLonLat.toString()
        },
        {
          heading: 'Elevazione',
          value: `${parseFloat(this.table_chart.elevation).toFixed(1)} m`
        },
        {
          heading: 'Distanza dal mare',
          value: `${parseFloat(this.table_chart.sea_distance).toFixed(1)} km`
        }];
        const data2_alternativeTemplate = [];

        Object.keys(data[0]).forEach(item => {
          if (item !== 'longitude' && item !== 'latitude' && item !== 'time') {
            const layer = this.rasterLayers.find(layer => `${layer.ws_name}:${layer.layer_name}` === item);
            const obj = {
              heading: formatLayerLabel(
                this.$t(`${item}_serviceID:${this.selectedRasterLayer.service_id}.label`),
                layer?.udm
              ),
              value: data[0][item]
            };
            data2_alternativeTemplate.push(obj);
          }
        });

        const pageContent = function (data) {
          // HEADER
          doc.setFontSize(20);
          doc.setTextColor(40);

          if (logoRadarmeteo) {
            doc.addImage(logoRadarmeteo, 'JPEG', data.settings.margin.left, 5, 10, 10);
          }

          doc.text(reportName, data.settings.margin.left + 13, 13);

          doc.setFontSize(6);
          doc.text(reportDate, data.settings.margin.left + 238, 13);

          // FOOTER
          let str = data.pageCount;

          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + ' di ' + totalPagesExp;
          }

          str += '          Radarmeteo s.r.l. Via Pontemanco, 68 - 35020, Due Carrare (PD) - Italia - Tel: (+39) 049 9125902 - Email: assistenza@radarmeteo.com - Web: www.radarmeteo.com';

          doc.setFontSize(6);
          doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);

          if (logoCertification) {
            doc.addImage(logoCertification, 'JPEG', doc.internal.pageSize.width - 34.25, doc.internal.pageSize.height - 14, 27.25, 10);
          }
        };

        doc.autoTable({
          columns: this.table_chart.header_alternativeTemplate,
          body: data1_alternativeTemplate,
          margin: { top: 20, horizontal: 7, left: 20, right: 20 },
          head: [[{ content: 'Ubicazione del rischio', colSpan: 2, styles: { fillColor: [12, 163, 68] } }]],
          bodyStyles: { valign: 'top' },
          styles: {
            overflow: 'linebreak',
            cellWidth: '150',
            fontSize: 6
          },
          columnStyles: { text: { cellWidth: 'auto' }, 0: { halign: 'left', cellWidth: 100, lineWidth: { right: 0.2 } } }
        });

        if (this.isAnimation) {
          doc.autoTable({
            didDrawPage: pageContent,
            columns: header,
            body: data,
            margin: { top: 20, horizontal: 7, left: 20, right: 20 },
            headStyles: { fillColor: [12, 163, 68] },
            bodyStyles: { valign: 'top' },
            styles: {
              overflow: 'linebreak',
              cellWidth: '150',
              fontSize: 6
            },
            columnStyles: { text: { cellWidth: 'auto' } }
          });
        } else {
          doc.autoTable({
            didDrawPage: pageContent,
            columns: this.table_chart.header_alternativeTemplate,
            body: data2_alternativeTemplate,
            margin: { top: 20, horizontal: 7, left: 20, right: 20 },
            head: [[{ content: 'Hazard Scores*', colSpan: 2, styles: { fillColor: [12, 163, 68] } }]],
            bodyStyles: { halign: 'center', valign: 'top' },
            styles: {
              overflow: 'linebreak',
              cellWidth: '150',
              fontSize: 6
            },
            columnStyles: { text: { cellWidth: 'auto' }, 0: { halign: 'left', cellWidth: 100, lineWidth: { right: 0.2 } } }
          });

          doc.setFontSize(6);
          doc.text('*la metodologia è riportata sui documenti tecnici', doc.lastAutoTable.settings.margin.left, doc.lastAutoTable.finalY + 4);
        }

        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp);
        }

        doc.save(fileName + '.pdf');
      } else {
        const rasterTableHeaders = [{ text: 'latitude', value: 'latitude', align: ' d-none' }, { text: 'longitude', value: 'longitude', align: ' d-none' }, ...this.table_chart.rasterTableHeaders];
        const currentTableItems = this.table_chart.rasterTableItems.map(item =>
          rasterTableHeaders.reduce((acc, header) => {
            const key = header.value;

            if (key in item) {
              acc[key] = item[key]; // Aggiungi la proprietà riordinata
            }

            return acc;
          }, {})
        );


        const headers = rasterTableHeaders.map(header => {
          if (header.text === 'time') {
            return { name: header.text, alias: this.$t('ServiceCard.date'), flex: 10 };
          } else {
            return { name: header.text, alias: header.text, flex: 1 };
          }
        });
        // eslint-disable-next-line no-undef
        objectExporter({
          exportable: currentTableItems,
          type: type,
          headers: headers,
          fileName: fileName,
          repeatHeader: false,
          headerStyle: 'font-weight: bold; padding: 5px; border: 1px solid #dddddd;',
          cellStyle: 'border: 1px solid lightgray; margin-bottom: -1px;',
          sheetName: 'Raster Table',
          documentTitle: 'Raster Table',
          documentTitleStyle: 'display:none'
        });
      }
    },
    exportChart(type) {
      html2canvas(this.$refs.chart.$refs.canvas, {
        backgroundColor: '#FFFFFF',
        allowTaint: true
      }).then(canvas => {
        const link = document.createElement('a');
        const reportName = this.getFilename();
        link.download = `${reportName}.${type}`;
        link.href = canvas.toDataURL(`image/${type}`);
        link.click();
      });
    },
    resetRasterForm() {
      this.chipSelectedRasterLayers = [];
      this.table_chart.allWorkspacesData = { data: {}, metadata: {} },
      this.table_chart.rasterTableHeaders = [{ text: this.$t('ServiceCard.date') }];
      this.table_chart.rasterTableItems = [];
      this.table_chart.rasterVectorChartLabels = [];
      this.table_chart.rasterVectorChartDataSetLine = [];
      this.table_chart.rasterVectorChartDataSetBar = [];
      this.tooltipData = null;
      this.legendItems = [];
      this.renderContent = false;
      this.table_chart.openRasterLayerTableChartPopup = false;
    },
    async updateRasterTableChart(rasters) {
      this.overlay = true;
      this.table_chart.rasterTableItems = [];
      this.table_chart.allWorkspacesData = { data: {}, metadata: {}, units: {} };

      if (rasters.length > 0) {
        const rastersForRequest = this.expandMultiVariableLayers(rasters);
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const groupLayersByWorkspace = rastersForRequest.reduce((r, a) => {
          r[a.ws_name] = [...r[a.ws_name] || [], a];

          return r;
        }, {});

        this.checkWpsLimits(groupLayersByWorkspace);

        if (!this.wpsLimitsExceeded) {
          for await (const workspace of Object.keys(groupLayersByWorkspace)) {
            const data = {
              time: this.tableChartRangeDate,
              username: this.app_user.username,
              workspace: workspace,
              layers: groupLayersByWorkspace[workspace].map(layer => layer.layer_name),
              latitude: this.map.coordsLonLat[1],
              longitude: this.map.coordsLonLat[0],
              output: 'json',
              timezone: timeZone,
              service_name: rasters[0].service_name,
              service_id: groupLayersByWorkspace[workspace].map(layer => layer.service_id)[0],
              layer_configs: groupLayersByWorkspace[workspace],
              group: this.$route.params.id,
              runtime: this.map.runtime[groupLayersByWorkspace[workspace].map(layer => layer.service_id)[0]]
            };
            await this.getLayerCoordinatesDataAction(data);
          }

          this.table_chart.allWorkspacesData.service_id = this.selectedRasterLayer.service_id;
          this.table_chart.allWorkspacesData.layers = rastersForRequest;
          await this.getUpdatedRasterTableChartAction(this.table_chart.allWorkspacesData);
        }

        if (this.table_chart.isTable) {
          this.table_chart.rasterTableHeaders = [{ text: this.$t('ServiceCard.date'), value: 'time' }];

          rastersForRequest.forEach(layer => {
            const layerKey = `${layer.ws_name}:${layer.layer_name}`;
            this.table_chart.rasterTableHeaders.push({
              text: formatLayerLabel(
                this.$t(`${layerKey}_serviceID:${layer.service_id}.label`),
                layer?.udm
              ),
              value: layerKey,
              sortable: true
            });
          });

          this.table_chart.rasterTableItems.forEach(item => {
            const header = this.table_chart.rasterTableHeaders.filter(e => !Object.keys(item).includes(e.value));

            if (header.length > 0) {
              header.forEach(h => item[h.value] = 'N/A');
            }
          });
        } else {
          this.renderCharts = false;
          this.tooltipData = null;
          this.legendItems = [];
          this.$nextTick(() => {
            this.renderCharts = true;
          });
        }

      } else {
        this.resetRasterForm();
      }

      this.overlay = false;
      this.renderContent = true;
    },
    expandMultiVariableLayers(rasters) {
      const expanded = rasters.flatMap(raster => {
        if (!raster.multi_variable_layers?.length) {
          return [raster];
        }

        return raster.multi_variable_layers.map(layerName => {
          const component = raster.multi_variable_layer_configs?.find(item => item.layer_name === layerName);

          return {
            ...raster,
            ...component,
            layer_name: layerName,
            is_multi_variable: false,
            multi_variable_layers: [],
            udm_conversions: null
          };
        });
      });

      return expanded.filter((raster, index, layers) => {
        return layers.findIndex(item => item.service_id === raster.service_id && item.ws_name === raster.ws_name && item.layer_name === raster.layer_name) === index;
      });
    },
    checkWpsLimits(workspaces) {
      // let HRS_limits = false;
      // let HFS_limits = false;
      Object.keys(workspaces).forEach(ws => {
        if (ws.toUpperCase().startsWith('HRS')) {
          const time = this.tableChartRangeDate.split('/');
          const [startDate, endDate] = time.map(t => moment(t));
          this.wpsLimitsExceeded = !!endDate.diff(startDate, 'year');
          // const timeDiff = endDate.diff(startDate, 'year');
          // HRS_limits = timeDiff > 0 || workspaces[ws].length > 5;
        }
        // if (ws.toUpperCase().startsWith('HFS')) {
        //   HFS_limits = workspaces[ws].length > 16;
        // }
      });
      // this.wpsLimitsExceeded = HRS_limits || HFS_limits;
    },
    limiterSelect(e) {
      if (!this.table_chart.isTable && e.length > 2) {
        this.storeToastMessage({
          text: this.$t('Graph.selectableLimit'),
          type: 'warning'
        });
        e.pop();
      }
    },
    calcWidth() {
      const lunghezza = this.table_chart.rasterVectorChartDataSetLine?.[0]?.data?.length ?? 0;

      let multiplier;

      if (lunghezza <= 100) {
        multiplier = 30;
      } else {
        multiplier = Math.max(30 - ((lunghezza - 100) / 100), 2);
      }

      return multiplier * lunghezza;
    }
  }
};
</script>

<style scoped>
#requests-table {
  white-space: nowrap !important;
}

.chart-tooltip-card {
  font-size: 13px;
}

.chart-tooltip-color {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}

.chart-legend {
  column-gap: 16px;
  row-gap: 4px;
}

.chart-legend-item {
  cursor: pointer;
  user-select: none;
  font-size: 13px;
}

.chart-legend-item--hidden {
  text-decoration: line-through;
  opacity: 0.5;
}

.chart-legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
}
</style>
